module.exports = __webpack_public_path__ + "images/icons/flags/NL-6daf8aeb.svg";